import { Vector3 } from 'three';
// ######################################################
//   Un tramo es una línea que va del punto A al punto B donde A y B son las
// coordenadas usadas para definir un perímtero en los editores.
//   Un tramo esta dividido en sub-secciones, debe existir una como mínimo.
//   Una sub-sección es por ejemplo una puerta, una verja o cercado sin muro ...
//
//   subSecction {
//	  x1, y1, // Puntos A de la sub-sección.
//	  x2, y2, // Puntos B de la sub-sección.
//    height // Altura en caso de que exista muro o escalones, (es la suma de ambos).
//    magnitud // Longitud de la sub-sección.
//    door // Es el ID de mongoDG, describe el tipo de puerta.
//   }
// ######################################################

export class SubSection {
	private _x1 = 0;
	private _y1 = 0;
	private _x2 = 0;
	private _y2 = 0;
	private _z1 = 0;
	private _z2 = 0;

	public height = 0;

	public magnitud: number;

	public door = '';
	public margenError = 0;

	public overflowLeft = false;	// La pueta sale por el lado A, subSection A -> B, (x1,y1) -> (x2, y2).
	public overflowRight = false;	// La pueta sale por el lado B, subSection A -> B, (x1,y1) -> (x2, y2).

	// Es el valor de una unidad (magnitud/100)
	public unidad = 1;

	// El poste base del tramo se ve obligado a moverse en x+, cuando:
	// 1.- El tramo anterior era una puerta.
	// 2.- La subsección del tramo anterior es más alto que el actual.
	public marginA = 0;

	// Cuando el poste base del siguiente tramo es obligado a moverse en x-, cuando:
	// 1.- El siguiente tramo es una puerta, se crea un nuevo poste y se desplaza (x = magnitud - 0.035).
	public marginB = 0;

	constructor(x1: number, y1: number, x2: number, y2: number, height = 0) {
		// console.log("MAGNITUD-constructor: ");
		this.setCoordinates(x1, y1, x2, y2);
		this.height = height;
	}

	public setCoordinates(x1: number, y1: number, x2: number, y2: number) {
		this._x1 = parseFloat(x1.toFixed(4));
		this._y1 = parseFloat(y1.toFixed(4));
		this._x2 = parseFloat(x2.toFixed(4));
		this._y2 = parseFloat(y2.toFixed(4));
		this.magnitud = parseFloat((Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))).toFixed(4));
		// console.log("MAGNITUD-Coorinates: " + this.magnitud);
		this.unidad = this.magnitud / 100;
	}

	public setCoordinatesXYZ(x1: number, y1: number, z1: number, x2: number, y2: number, z2: number) {
		this._x1 = parseFloat(x1.toFixed(4));
		this._y1 = parseFloat(y1.toFixed(4));
		this._z1 = parseFloat(z1.toFixed(4));
		this._x2 = parseFloat(x2.toFixed(4));
		this._y2 = parseFloat(y2.toFixed(4));
		this._z2 = parseFloat(z2.toFixed(4));
		let va = new Vector3(x1, y1, z1);
		this.magnitud = Math.floor(va.distanceTo(new Vector3(x2, y2, z1)) * 10000) / 10000;
		console.log(this.magnitud);
		this.unidad = this.magnitud / 100;
	}
	

	public setCoordinates2(x2: number, y2: number) {
		this._x2 = parseFloat(x2.toFixed(4));
		this._y2 = parseFloat(y2.toFixed(4));
		this.magnitud = parseFloat((Math.sqrt(Math.pow(this._x1 - x2, 2) + Math.pow(this._y1 - y2, 2))).toFixed(4));
		this.unidad = this.magnitud / 100;
	}

	public setCoordinatesZ(z1: number, z2: number) {
		this._z1 = parseFloat(z1.toFixed(4));
		this._z2 = parseFloat(z2.toFixed(4));
		let va = new Vector3(this._x1, this._y1, z1);
		this.magnitud = Math.floor(va.distanceTo(new Vector3(this._x2, this._y2, z1)) * 10000) / 10000;
		this.unidad = this.magnitud / 100;
	}

	public get x1() { return this._x1; }
	public get y1() { return this._y1; }
	public get z1() { return this._z1; }
	public get x2() { return this._x2; }
	public get y2() { return this._y2; }
	public get z2() { return this._z2; }
}